module.exports = __webpack_public_path__ + "static/media/house-blue.e016184a.svg";